import { useConfiguration } from '@ocx-app/modules/configuration/useConfiguration';

export const useSpireConfig = () => {
  const { config } = useConfiguration();
  return config.spireEnrollment;
};
